<template>
  <UserDetail />
</template>

<script>
import UserDetail from "@/components/user/UserDetail";

export default {
  name: 'UserView',
  components: {UserDetail},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
